import * as actionTypes from './actionTypes'

const initialState = {
    user: null,
    error: null,
    signingIn: false,
    authenticated: null,
    forgotPassword: { success: false, error: null, loading: false },
    resetPassword: { success: false, error: null, loading: false },
    userList: { users: [], total: 0, pageSize: 0, error: null, loading: false },
    activeUser: { user: null, error: null, loading: false },
    newUser: { user: null, error: null, loading: false },
    updateUser: { user: null, error: null, loading: false },
    deleteUser: { user: null, error: null, loading: false },
    uploadPhoto: { photoUrl: null, error: null, loading: false },
    deleteUserPhoto: { success: false, error: null, loading: false },
}

export default (state = initialState, action) => {

    switch (action.type) {
        case actionTypes.LOGIN_USER:
            return { ...state, user: null, error: null, signingIn: true }

        case actionTypes.LOGIN_USER_SUCCESS:
            return { ...state, user: action.payload.user, error: null, signingIn: false, authenticated: true }

        case actionTypes.LOGIN_USER_FAILURE:
            return { ...state, user: null, error: action.payload.error, signingIn: false, authenticated: false }


        case actionTypes.REQUEST_FORGOT_PASSWORD:
            return { ...state, forgotPassword: { success: false, error: null, loading: true } }

        case actionTypes.REQUEST_FORGOT_PASSWORD_SUCCESS:
            return { ...state, forgotPassword: { success: true, error: null, loading: false } }

        case actionTypes.REQUEST_FORGOT_PASSWORD_FAILURE:
            return { ...state, forgotPassword: { success: false, error: action.payload.error, loading: false } }

        case actionTypes.RESET_REQUEST_FORGOT_PASSWORD:
            return { ...state, forgotPassword: initialState.forgotPassword }


        case actionTypes.REQUEST_RESET_PASSWORD:
            return { ...state, resetPassword: { success: false, error: null, loading: true } }

        case actionTypes.REQUEST_RESET_PASSWORD_SUCCESS:
            return { ...state, resetPassword: { success: true, error: null, loading: false } }

        case actionTypes.REQUEST_RESET_PASSWORD_FAILURE:
            return { ...state, resetPassword: { success: false, error: action.payload.error, loading: false } }

        case actionTypes.RESET_REQUEST_RESET_PASSWORD:
            return { ...state, resetPassword: initialState.resetPassword }


        case actionTypes.FETCH_USERS:
            return { ...state, userList: { ...state.userList, error: null, loading: true } }

        case actionTypes.FETCH_USERS_SUCCESS:
            return { ...state, userList: { users: action.payload.users, total: action.payload.total, pageSize: action.payload.pageSize, error: null, loading: false } }

        case actionTypes.FETCH_USERS_FAILURE:
            return { ...state, userList: { users: [], total: 0, pageSize: 0, error: action.payload.error, loading: false } }

        case actionTypes.RESET_USERS:
            return { ...state, userList: initialState.userList }



        case actionTypes.FETCH_USER_DETAIL:
            return { ...state, activeUser: { user: null, error: null, loading: true } }

        case actionTypes.FETCH_USER_DETAIL_SUCCESS:
            return { ...state, activeUser: { user: action.payload.user, error: null, loading: false } }

        case actionTypes.FETCH_USER_DETAIL_FAILURE:
            return { ...state, activeUser: { user: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_USER_DETAIL:
            return { ...state, activeUser: initialState.activeUser }



        case actionTypes.CREATE_USER:
            return { ...state, newUser: { user: null, error: null, loading: true } }

        case actionTypes.CREATE_USER_SUCCESS:
            return { ...state, newUser: { user: action.payload.user, error: null, loading: false } }

        case actionTypes.CREATE_USER_FAILURE:
            return { ...state, newUser: { user: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_CREATE_USER:
            return { ...state, newUser: initialState.newUser }



        case actionTypes.UPDATE_USER:
            return { ...state, updateUser: { user: null, error: null, loading: true } }

        case actionTypes.UPDATE_USER_SUCCESS:
            return { ...state, updateUser: { user: action.payload.user, error: null, loading: false } }

        case actionTypes.UPDATE_USER_FAILURE:
            return { ...state, updateUser: { user: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_UPDATE_USER:
            return { ...state, updateUser: initialState.updateUser }


        case actionTypes.DELETE_USER:
            return { ...state, deleteUser: { user: null, error: null, loading: true } }

        case actionTypes.DELETE_USER_SUCCESS:
            return { ...state, deleteUser: { user: action.payload.user, error: null, loading: false } }

        case actionTypes.DELETE_USER_FAILURE:
            return { ...state, deleteUser: { user: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_USER:
            return { ...state, deleteUser: initialState.deleteUser }


        case actionTypes.UPLOAD_USER_PHOTO:
            return { ...state, uploadPhoto: { photoUrl: null, error: null, loading: true } }

        case actionTypes.UPLOAD_USER_PHOTO_SUCCESS:
            return { ...state, uploadPhoto: { photoUrl: action.payload.photoUrl, error: null, loading: false } }

        case actionTypes.UPLOAD_USER_PHOTO_FAILURE:
            return { ...state, uploadPhoto: { photoUrl: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_UPLOAD_USER_PHOTO:
            return { ...state, uploadPhoto: initialState.uploadPhoto }


        case actionTypes.DELETE_USER_PHOTO:
            return { ...state, deleteUserPhoto: { success: false, error: null, loading: true } }

        case actionTypes.DELETE_USER_PHOTO_SUCCESS:
            return { ...state, deleteUserPhoto: { success: true, error: null, loading: false } }

        case actionTypes.DELETE_USER_PHOTO_FAILURE:
            return { ...state, deleteUserPhoto: { success: false, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_USER_PHOTO:
            return { ...state, deleteUserPhoto: initialState.deleteUserPhoto }


        case actionTypes.LOGOUT_USER:
            return { ...initialState, authenticated: false }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/user/reducer.js